"use client"

import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { useProjects } from "../contexts/ProjectContext"
import { hasCompletedPaymentOrBypass } from "../utils/paymentGate"

const Signup = () => {
  // Commented out for email/password flow (kept for future use)
  // const [email, setEmail] = useState("")
  // const [password, setPassword] = useState("")
  // const [confirmPassword, setConfirmPassword] = useState("")
  // const [showPassword, setShowPassword] = useState(false)
  // const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [error, setError] = useState("")
  // const [message, setMessage] = useState("")
  const { signInWithGoogle, loading } = useAuth()
  const { loadProjects } = useProjects()
  const navigate = useNavigate()

  // Commented out for email/password flow (kept for future use)
  // const validatePassword = (password) => {
  //   const requirements = {
  //     length: password.length >= 6,
  //     uppercase: /[A-Z]/.test(password),
  //     number: /[0-9]/.test(password)
  //   }
  //   return requirements
  // }

  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  //   setError("")
  //   setMessage("")

  //   if (!email || !password) {
  //     setError("Please enter both email and password")
  //     return
  //   }

  //   const passwordReqs = validatePassword(password)
  //   if (!passwordReqs.length || !passwordReqs.uppercase || !passwordReqs.number) {
  //     setError("Password must contain at least 6 characters, one uppercase letter, and one number")
  //     return
  //   }

  //   if (password !== confirmPassword) {
  //     setError("Passwords do not match")
  //     return
  //   }

  //   const { success, error } = await signUp(email, password)
  //   if (success) {
  //     // Redirect to checkout page after successful signup
  //     navigate('/checkout')
  //   } else {
  //     setError(error || "Failed to sign up")
  //   }
  // }

  const handleGoogleSignIn = async () => {
    setError("")
    const { success, error } = await signInWithGoogle()
    if (success) {
      if (hasCompletedPaymentOrBypass()) {
        await loadProjects()
        navigate('/onboarding/business')
      } else {
        navigate('/checkout')
      }
    } else {
      setError(error || "Failed to sign in with Google")
    }
  }

  // Commented out for email/password flow (kept for future use)
  // const passwordRequirements = [
  //   { met: password.length >= 6, text: "At least 6 characters" },
  //   { met: /[A-Z]/.test(password), text: "One uppercase letter" },
  //   { met: /[0-9]/.test(password), text: "One number" },
  // ]

  return (
    <div className="min-h-screen flex">
      <div className="w-full grid md:grid-cols-[60%_40%]">
        {/* Left Column - Auth */}
        <div className="bg-white flex items-center justify-center px-4 py-12">
          <div className="max-w-lg w-full">
          <div className="text-center mb-8">
            <h1 className="text-5xl font-bold mb-3">
              Welcome to <span className="text-[#1ba6ff]">Hyperrank</span>
            </h1>
            <p className="text-xl text-gray-600">
              Outrank your competitors on auto-pilot!
            </p>
          </div>

          {/* Social Proof */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="flex -space-x-2">
              <img
                src="https://i.pravatar.cc/150?img=1"
                alt="User"
                className="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                src="https://i.pravatar.cc/150?img=2"
                alt="User"
                className="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                src="https://i.pravatar.cc/150?img=3"
                alt="User"
                className="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                src="https://i.pravatar.cc/150?img=4"
                alt="User"
                className="w-10 h-10 rounded-full border-2 border-white"
              />
            </div>
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
                    <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                  </svg>
                ))}
              </div>
              <span className="text-sm font-medium text-gray-700">50k+ Articles Created</span>
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg mb-6">
              <p className="text-red-700 text-sm">{error}</p>
            </div>
          )}

          {/* Google Sign Up Button */}
          <div className="space-y-4">
            <button
              type="button"
              onClick={handleGoogleSignIn}
              disabled={loading}
              className="w-full h-14 bg-white border-2 border-[#1ba6ff] hover:bg-blue-50 disabled:bg-gray-200 disabled:cursor-not-allowed text-gray-700 font-semibold rounded-full transition-all duration-200 flex items-center justify-center shadow-md hover:shadow-lg"
            >
              <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              {loading ? 'Processing...' : 'Continue with Google'}
            </button>

            {/* Sign In Link */}
            <div className="text-center pt-4">
              <p className="text-gray-600">
                Already have an account?{" "}
                <Link to="/login" className="text-[#1ba6ff] hover:text-[#1590e6] font-semibold transition-colors duration-200">
                  Sign in
                </Link>
              </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Testimonial */}
        <div className="hidden md:flex items-center justify-center px-4 py-12 bg-gradient-to-br from-blue-50 to-cyan-50">
          <div className="max-w-lg w-full relative">
            {/* Large quotation mark positioned above the box */}
            <div className="absolute -top-4 -left-4 z-10">
              <svg className="w-24 h-24 text-blue-200 opacity-60" fill="currentColor" viewBox="0 0 100 100">
                <text x="0" y="80" fontSize="120" fontFamily="Georgia, serif">"</text>
              </svg>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-8 relative overflow-visible">
            <div className="flex items-center gap-4 mb-6">
              <img
                src="https://i.pravatar.cc/150?img=12"
                alt="Testimonial"
                className="w-16 h-16 rounded-full"
              />
              <div>
                <h3 className="font-bold text-lg text-gray-900">Sarah Mitchell</h3>
                <p className="text-gray-600 text-sm">Founder of ContentFlow</p>
              </div>
            </div>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                I'm quite <span className="font-semibold text-gray-900">amazed by the quality</span> of Hyperrank
                for programmatic blog content generation.
              </p>
              <p>
                It is the first time I don't feel ashamed to post AI content as it is, and I genuinely can't
                wait until the next day to check the Hyperrank dashboard and see what it has generated for me!
              </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Signup

/* Commented out Email/Password Signup Form (kept for future use)

<form onSubmit={handleSubmit} className="space-y-5">
  <div className="space-y-2">
    <label htmlFor="email" className="block text-sm font-medium text-slate-700">
      Email Address
    </label>
    <div className="relative">
      <svg
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
      <input
        type="email"
        id="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full pl-10 pr-4 py-3 h-12 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1ba6ff] focus:border-[#1ba6ff] transition-colors"
        placeholder="Enter your email"
        required
      />
    </div>
  </div>

  <div className="space-y-2">
    <label htmlFor="password" className="block text-sm font-medium text-slate-700">
      Password
    </label>
    <div className="relative">
      <svg
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
        />
      </svg>
      <input
        type={showPassword ? "text" : "password"}
        id="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="w-full pl-10 pr-10 py-3 h-12 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1ba6ff] focus:border-[#1ba6ff] transition-colors"
        placeholder="Create a password"
        required
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
      >
        {showPassword ? (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
            />
          </svg>
        ) : (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
        )}
      </button>
    </div>

    {password && (
      <div className="mt-2 space-y-1">
        {passwordRequirements.map((req, index) => (
          <div key={index} className="flex items-center text-xs">
            <svg
              className={`w-3 h-3 mr-2 ${req.met ? "text-green-500" : "text-slate-300"}`}
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span className={req.met ? "text-green-600" : "text-slate-500"}>{req.text}</span>
          </div>
        ))}
      </div>
    )}
  </div>

  <div className="space-y-2">
    <label htmlFor="confirm-password" className="block text-sm font-medium text-slate-700">
      Confirm Password
    </label>
    <div className="relative">
      <svg
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
        />
      </svg>
      <input
        type={showConfirmPassword ? "text" : "password"}
        id="confirm-password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        className="w-full pl-10 pr-10 py-3 h-12 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1ba6ff] focus:border-[#1ba6ff] transition-colors"
        placeholder="Confirm your password"
        required
      />
      <button
        type="button"
        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
      >
        {showConfirmPassword ? (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
            />
          </svg>
        ) : (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
        )}
      </button>
    </div>
  </div>

  <button
    type="submit"
    disabled={loading}
    className="w-full flex items-center justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-base font-medium text-white bg-[#1ba6ff] hover:bg-[#0a95ee] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1ba6ff] transition-colors disabled:opacity-50"
  >
    {loading ? (
      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
      </svg>
    ) : null}
    {loading ? "Processing..." : "Continue to Payment"}
  </button>
</form>

<div className="relative">
  <div className="absolute inset-0 flex items-center">
    <div className="w-full border-t border-gray-200"></div>
  </div>
  <div className="relative flex justify-center text-sm">
    <span className="px-2 bg-white text-gray-500">Or continue with</span>
  </div>
</div>

*/
